<script>
  import { _ } from "svelte-i18n";
  import { changeToken } from "../../../../../../Api";
  import { api } from "../../../../../../helpers";
  import { info_client } from "../../../../../stores";
    import { addToast } from "../../../../Toasts/store";
  
  export let comment;

  // Удаление лайка
  const deleteLike = async (pk) => {
    await api(`/api/v1/like-comment/delete/${pk}/`, 'DELETE');
  };

  // Добавление лайка
  const postLike = async (dataLike) => {
    const response = await api(
      `/api/v1/like-comment/create/${comment.pk}/`, 
      'POST', 
      dataLike,
    );

    if (!response.ok) {
      changeToken(response.status);
    }
  };

  function changeLike() {
    if(comment.i_liked === false){
      if(comment.is_my_comment){
        addToast($_('thisIsYourComment'));
      }else{
        const dataLike = new FormData();
        dataLike.append('jwt_client', $info_client.pk);
        dataLike.append('comment', comment.pk);
        dataLike.append('like', comment.like_count + 1);
        postLike( dataLike );
        comment.like_count = comment.like_count + 1;
        comment.i_liked = true;
      }
    }else{
      deleteLike(comment.pk);
      comment.like_count = comment.like_count - 1;
      comment.i_liked = false;
    };
  };
</script>

<div class="likes text-grey text-bold" on:click={changeLike}>
  <i 
    class:icon-heart-full={comment.i_liked}
    class:icon-heart-border={!comment.i_liked}
  />
  <span>{comment.like_count}</span>
</div>

<style>
  .likes {
    cursor: pointer;  
    background-color:transparent;
    border:none;
    font-size: 12px;
    line-height: 18px;
  }

  .icon-heart-full {
    color: #FA624B;
  }

  .icon-heart-border {
    color: #BDBFC4;
  }
</style>